module.exports = __webpack_public_path__ + "3b5a094f89a60565e3f48f472f5233b9.woff2";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/LabilGrotesk-Medium.woff2
// module id = 32
// module chunks = 0 1